import { memo } from 'react'

import { AnimatedSpinner } from '../../../../components/AnimatedSpinner'
import { IUserData } from '../../../../store/reducers/userReducer'
import { TwinCreationContent } from './TwinCreationContent'
import { TwinReadyContent } from './TwinReadyContent'

export interface MainTabProps {
  user: IUserData | null
  locationSearch: string | null
  isLoading: boolean
  isReadyStatus: boolean
  twinImageUrl: string
  openNextTab: () => void
}

const MainTab: React.FC<MainTabProps> = memo(
  ({
    user,
    locationSearch,
    isLoading,
    isReadyStatus,
    twinImageUrl,
    openNextTab,
  }) => {
    if (isLoading || !user)
      return (
        <div className="h-full relative grow flex flex-col items-center justify-center  px-4 py-10">
          <div className="h-12 w-12 rounded-full bg-dark-neutral-500 text-white flex items-center justify-center mb-8">
            <AnimatedSpinner />
          </div>
        </div>
      )

    return (
      <>
        {user?.mentorId && isReadyStatus ? (
          <TwinReadyContent
            user={user}
            locationSearch={locationSearch}
            twinImageUrl={twinImageUrl}
          />
        ) : (
          <TwinCreationContent openNextTab={openNextTab} />
        )}
      </>
    )
  },
)

export { MainTab }
